import React from 'react';
import PropTypes from 'prop-types';

import Heading from '@marvelapp/marvel-ui/heading';
import MaxWidth from '@marvelapp/marvel-ui/max-width';
import Spacing from '@marvelapp/marvel-ui/spacing';

import styles from './styles/general.module.css';

export default function HeadingCopy({ title, subheading }) {
  return (
    <Spacing type="margin" position="topBottom" size="xl">
      <Heading tag="h1" size="xxxxl" weight="semibold">
        {title}
      </Heading>
      <MaxWidth value={720}>
        <h2 className={styles.subheading}>{subheading}</h2>
      </MaxWidth>
    </Spacing>
  );
}

HeadingCopy.propTypes = {
  title: PropTypes.string.isRequired,
  subheading: PropTypes.string.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/modules/HeadingCopy/HeadingCopy.js